import BookBlock from './bookblock';
const vBookBlock = {};

if (!BookBlock) {
  throw new Error('[vue-bookblock] cannot locate BookBlock.js.');
}

// exposed global options
vBookBlock.config = {};

vBookBlock.install = function(Vue) {
  Vue.directive('BookBlock', {
    bind: function(el, binding) {
      el.bookblock = new BookBlock(el, binding.value || vBookBlock.config);
    },
    // inserted: function (el, binding) {
    //   el.bookblock = new BookBlock(el, binding.value || vBookBlock.config)
    // },
    componentUpdated: function(el, binding, vnode, oldVnode) {
      if (vnode.children.length != oldVnode.children.length) {
        let allPage = el.querySelectorAll('.page');
        let firstPageStyle = allPage[0].style;
        for (let [index, page] of el.querySelectorAll('.page').entries()) {
          if (index != 0) {
            page.style.cssText = firstPageStyle.cssText;
          }
        }
        el.bookblock.update();
      }
    },
  });
};

export default vBookBlock;
